"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateBodyLength = void 0;
var serde_1 = require("@smithy/core/serde");
Object.defineProperty(exports, "calculateBodyLength", { enumerable: true, get: function () { return serde_1.calculateBodyLength; } });
